import {Link} from "@inertiajs/inertia-react";
import Pagination from "@/Components/Pagination";
import {OrganizationUserStatus} from "@/Enums/OrganizationUserStatus";

export default function PeopleTableBody({state, dispatch, setIsDeletePersonConfirmationOpen}) {
    function statusCellTemplate(status) {
        return (
            <td data-testid="people_table_body-td-status">
                {status === OrganizationUserStatus.INVITED &&
                    <span className="status status-invited">
                        Invitation Sent
                    </span>
                }
                {status ===  OrganizationUserStatus.ACTIVE &&
                    <div className="status status-active">
                        Authenticated
                    </div>
                }
                {status ===  OrganizationUserStatus.DISABLED &&
                    <div className="status status-disabled">
                        Access Disabled
                    </div>
                }
            </td>
        );
    }

    function deletePerson(person) {
        dispatch({ type: "deletePersonConfirmation", payload: { deletePersonConfirmation: {
                    isOpen: true,
                    person: person,
                    setIsOpen: setIsDeletePersonConfirmationOpen
                }}});
    }

    function editPerson(person) {
        dispatch({ type: "person", payload: { person: person }});
        dispatch({ type: "personSliderReady", payload: { personSliderReady: true }});
        dispatch({ type: "showPersonSlider", payload: { showPersonSlider: true }});
    }

    return (
        <tbody>
            {state.users.map((person, i) =>
                {
                    const isOrganizationOwner = person.organization_owner;

                    return (
                        <tr key={person.id}>
                            <td data-testid="people_table_body-td-name"><Link href="" onClick={(event) => {
                                event.preventDefault();
                                editPerson(person);
                            }} preserveState>{person.first_name} {person.last_name}</Link></td>
                            <td data-testid="people_table_body-td-phone" className="d-none d-md-table-cell"
                                nowrap={"true"}>{person.phone}</td>
                            <td data-testid="people_table_body-td-email"
                                className="d-none d-sm-table-cell">{person.email}</td>
                            {statusCellTemplate(person.status)}

                            <td data-testid="people_table_body-td-added_on" className="table-fit"
                                style={{cursor: "not-allowed"}}>
                                {new Date(person.created_at).toLocaleDateString()}
                            </td>

                            {isOrganizationOwner &&
                                <td data-testid="people_table_body-td-actions" className="table-fit"
                                    style={{cursor: "not-allowed"}}>
                                    <button disabled="disabled" className="btn btn-toolbar p-0 text-secondary">
                                        <i className="fa fa-trash"></i>
                                    </button>
                                </td>
                            }
                            {!isOrganizationOwner &&
                                <td data-testid="people_table_body-td-actions" className="table-fit"
                                    style={{cursor: "not-allowed"}}>
                                    <button onClick={() => deletePerson(person)}
                                            className="btn btn-toolbar p-0 text-secondary">
                                        <i className="fa fa-trash"></i>
                                    </button>
                                </td>
                            }
                        </tr>
                    )
                }
            )}
            <tr>
                <td colSpan="100%">
                    <Pagination state={state} dispatch={dispatch}/>
                </td>
            </tr>
        </tbody>
    )
}
